import { render, staticRenderFns } from "./AlreadyReturnDetail.vue?vue&type=template&id=2efa0794&"
import script from "./AlreadyReturnDetail.vue?vue&type=script&lang=js&"
export * from "./AlreadyReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlreadyReturnDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports